import {BufferGeometry} from 'three'
import GenericLoader from 'js/3d/lib/genericLoader'

// A loader tha should only be used to load
// non-existant geometry. Will produce a legitmate
// scene graph object, but it will not result in any
// pixels lighting up.
//
// Primarily used for 3D diffs, where a null component
// is easier to manage than a series of special cases
class NullLoader extends GenericLoader {
  constructor(...args) {
    super(...args)
    this.load = this.load.bind(this)
    this.parse = this.parse.bind(this)
  }

  load() {
    this.dispatchEvent({
      type: 'load',
      content: this.parse()
    })
  }

  parse() {
    const geometry = new BufferGeometry()
    geometry.computeFaceNormals()
    geometry.computeBoundingBox()
    geometry.computeBoundingSphere()
    return geometry
  }
}

GenericLoader.extensions['noop'] = NullLoader

export default NullLoader
